import { render, staticRenderFns } from "./AllCompanies.vue?vue&type=template&id=f99f8e52&scoped=true&"
import script from "./AllCompanies.vue?vue&type=script&lang=js&"
export * from "./AllCompanies.vue?vue&type=script&lang=js&"
import style0 from "./AllCompanies.vue?vue&type=style&index=0&id=f99f8e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99f8e52",
  null
  
)

export default component.exports